import { FieldName, MinMaxProps, RangeName } from './types';

type RangeFieldsConfig = {
  fromField: FieldName.priceFrom | FieldName.areaFrom | FieldName.floorFrom;
  toField: FieldName.priceTo | FieldName.areaTo | FieldName.floorTo;
  minProp: keyof MinMaxProps;
  maxProp: keyof MinMaxProps;
};

export const rangeFieldsConfig: Record<RangeName, RangeFieldsConfig> = {
  [RangeName.price]: {
    fromField: FieldName.priceFrom,
    toField: FieldName.priceTo,
    minProp: 'priceMin',
    maxProp: 'priceMax',
  },
  [RangeName.area]: {
    fromField: FieldName.areaFrom,
    toField: FieldName.areaTo,
    minProp: 'areaMin',
    maxProp: 'areaMax',
  },
  [RangeName.floor]: {
    fromField: FieldName.floorFrom,
    toField: FieldName.floorTo,
    minProp: 'floorMin',
    maxProp: 'floorMax',
  },
};

type MinMaxConfig<T> = [field: FieldName, prop: keyof T][];

export const minMaxFieldsConfig: MinMaxConfig<MinMaxProps> = Object.values(rangeFieldsConfig).flatMap(
  ({ fromField, toField, minProp, maxProp }): MinMaxConfig<MinMaxProps> => [
    [fromField, minProp],
    [toField, maxProp],
  ],
);
